/**
 * Check if some HTML is empty.
 */
export function isEmpty(html: string | null | undefined): boolean {
    if (!html) {
        return true;
    }
    const strWithoutTags = html.replace(/<[^>]*>?/g, "");
    return strWithoutTags.trim() === "";
}

export function isTiptapDocumentEmpty(doc: any) {
    // Check if doc has no content or only contains empty paragraphs
    if (!doc || !doc.content || doc.content.length === 0) {
        return true;
    }

    // Check if all content blocks are empty
    return doc.content.every((node: any) => {
        // Empty paragraph
        if (node.type === "paragraph" && (!node.content || node.content.length === 0)) {
            return true;
        }

        // Paragraph with only empty text nodes
        if (node.type === "paragraph" && node.content) {
            return node.content.every((textNode: any) => textNode.type === "text" && (!textNode.text || textNode.text.trim() === ""));
        }

        // Other node types - consider them as content
        return false;
    });
}
